module.exports = __webpack_public_path__ + "img/ico-thumbnail.fc31e1df.svg";